export default __webpack_public_path__ + "static/media/knight_of_cups.01b53aa2.png";